import React from "react";
import "./ScorecardSummaryTableSticky.css"; // Import the CSS file
import ScorecardSummaryTableStickyRow from "./ScorecardSummaryTableStickyRow";
import ScorecardSummaryTableStickyHeader from "./ScorecardSummaryTableStickyHeader";

function ScorecardSummaryTableSticky({
  players,
  // onJumpToHole,
  throwScoringModeId,
  maxHole,
}) {
  return (
    <div className="table-wrapper">
      <table>
        <thead>
          <ScorecardSummaryTableStickyHeader
            throwScoringModeId={throwScoringModeId}
            maxHole={maxHole}
          />
        </thead>
        <tbody>
          {players?.map((player, index) => {
            return (
              <ScorecardSummaryTableStickyRow
                player={player}
                key={index}
                throwScoringModeId={throwScoringModeId}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ScorecardSummaryTableSticky;
